<template>
  <div>
    <Search
      v-if="url"
      :allowFields="$lang.searchPartner"
      :allowCollapse="false"
      :url="url"
      :title="$lang.partner"
      config="searchPartner"
      addModalSize="lg"
      removeModalSize="xl"
      :visibleSearch="false"
      :visibleSettings="false"
      :visibleExport="false"
      :visibleFilters="false"
      :visibleViewCount="false"
      :visibleAdd="false"
      :allowEdit="false"
      :toggleable="true"
      :visibleAccordion="true"
      ref="searchPartner"
      :dynamicButtons="buttons"
      :parentPermissions="parentPermissions"
      :params="`relation_type_id=${$config.relation_type.partnerform}`"
      @getPermisson="getPermisson"
      :showAlert="true"
      :titleAlert="$lang.partner_information"
      colorAlert="success"
      :remove_item="remove_item"
    />
  </div>
</template>

<script>
import Search from "@/components/base/search";
import { generateApiUrl } from "@/shared/utils";

export default {
  inject: ["personRelationRepository"],
  components: {
    Search,
  },
  props: {
    code: {
      type: [String, Number],
      default: null,
    },
    parentPermissions: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      itemId: null,
      permission: false,
      buttons: [
        {
          id: 0,
          name: "edit",
          click: this.changeEdit,
        },
        {
          id: "1",
          name: "view",
          click: this.changeEdit,
        },

        {
          id: "3",
          name: "delete",
        },
      ],
    };
  },
  computed: {
    url() {
      return generateApiUrl(
        ["resources", "person_relation_paginate"],
        [this.code]
      );
    },
  },
  methods: {
    generateApiUrl,
    async remove_item(item) {
      try {
        const response = await this.personRelationRepository.delete(
          this.code,
          item.id
        );
        this.$notify.success(response.data.message);
        return true;
      } catch (error) {
        this.$generateError(error);
        return false;
      }
    },
    getPermisson(permissions) {
      this.permission = permissions.includes("admin");
    },
    changeEdit(item) {
      this.itemId = item.id;
    },
  },
};
</script>

